<template>
    <div class="table-user">
        <div class="mb-3 text-right pt-1 table-user-header">
            <b-row class="mb-3">
                <search-field @searchValue="searchField($event)" />
                <date-filters @dateFromAction="filterTable($event)" @dateToAction="filterTable($event)" />
            </b-row>
        </div>
        <div class="scroll-x">
            <table-element
                :items="items"
                :fields="fields"
                :status="statusOptions"
                :row-class="rowClass"
                @sort="event => sortTable(event)"
                @statusFiltered="event => filterTable(event)">
                <div slot="status" slot-scope="data">
                    <div v-if="data.item.status === 'recommend_for_return'">
                        <span v-b-popover.hover="getPopoverText(data.item.status)"
                                class="text-danger product-popover">
                                <IconCommentAltExclamation />
                        </span>
                        <span>{{data.value}}</span>
                    </div>
                    <template v-else>
                        {{data.value}}
                    </template>
                </div>
                <b-btn slot="actions"
                       slot-scope="data"
                       size="sm"
                       :to="redirectTo(data.item)"
                       variant="primary-user">Work on shipping plan</b-btn>
            </table-element>
        </div>
        <div class="table-user-footer">
            <!-- Pagination -->
            <table-pagination
                v-if="settingsPaginationFromApi.total >= quantityProductOnPage"
                @paginateAction="updatePagination"
                :settings="settingsPaginationFromApi"
                :perPageArray="quantityProductVariations"/>
        </div>
    </div>
</template>

<script>
    import {tableMixins, paginationMixin, routePaginationMixin} from '@/mixins/tableMixins'

    import TableElement from '~cp/UserPanel/Elements/TableElement'
    import SearchField from '~cp/UserPanel/Elements/SearchField'
    import DateFilters from '~cp/UserPanel/Elements/DateFilters'
    import TablePagination from '~cp/UserPanel/Elements/TablePagination'

    import replenishmentColumns from '@/assets/js/columns/replenishmentInventory'
    import replenishmentPlans from '@/assets/js/columns/replenishmentPlans'
    import replenishmentStatus from '@/assets/js/status/replenishment/shipment'

    import IconCommentAltExclamation from '~cp/UserPanel/Elements/Icons/CommentAltExclamation'

    export default {
        name: 'ReplenishmentPlanning',
        mixins: [tableMixins, paginationMixin, routePaginationMixin],
        components: {
            TableElement,
            SearchField,
            DateFilters,
            TablePagination,
            IconCommentAltExclamation
        },
        data() {
            return {
                endpoint: this.$endpoints.incomesPlans,
                fields: [...replenishmentColumns, ...replenishmentPlans],
                statusOptions: replenishmentStatus,
            }
        },
        computed: {
            redirectTo() {
                return (replenishment) => {
                    return {
                        name: replenishment.itemsTotalCount > 0 ? 'ReplenishmentItem' : 'ReplenishmentAddProducts',
                        params: {
                            parent: 'plans',
                            planId: replenishment.id,
                        },
                        query: {
                            planNumber: replenishment.uniqueNumber || replenishment.id
                        }
                    }
                }
            }
        },
        methods: {
            rowClass(item) {
                if (!item) return
                if (item.status === 'recommend_for_return') {
                    return 'table-danger'
                }
            },
            getPopoverText(status) {
                switch (status) {
                    case 'recommend_for_return':
                        return 'Recommended for return'
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/UserPanel/Pages/Inventory/Replenishment/ReplenishmentPlans.vue